import {
  LOCAL_DICT_MAP,
  LOCAL_EMPTY_DATA,
  LOCAL_TRANSFOR_DICT,
  LOCAL_STRING_DICT,
  LOCAL_FILTER_DICT,
  SPEC_DICT
} from './config';
// import { $t } from '@/plugins/i18n';

const TRANSFOR_KEY = '_transforKey'; // 转换标记

// 二、数据处理
export class DynamicDictModel {
  init($t) {
    let dictList = [];

    // 改为使用架构的数据字典
    const remoteDictList = JSON.parse(localStorage.getItem('dict-map') || '[]');
    remoteDictList.forEach(dict => {
      const { code: categoryCode, dictionaryList: child } = dict;
      if (child) {
        const result = child.map(dit => {
          return {
            categoryCode,
            code: dit.code,
            name: $t ? $t(dit.name) : dit.name,
            id: dit.id
          };
        });
        dictList = dictList.concat(result);
      }
    });
    // console.error(dictList);
    const remoteDict = this.groupByCategoryCode(dictList);

    const result = Object.entries(LOCAL_EMPTY_DATA).reduce(
      (result, [key, localDictValue]) => {
        let dictData = remoteDict[key] || localDictValue;
        dictData = this.trasnformValue(key, dictData);
        dictData = this.filterValue(key, dictData);
        result[key] = dictData;
        return result;
      },
      {}
    );
    return result;
  }

  // ① 将接口枚举数据按【CategoryCode】类型分组
  groupByCategoryCode(dictList) {
    try {
      return dictList.reduce((dictData, dictItem) => {
        const { categoryCode: remoteKey } = dictItem;

        const _dictItem = this.pickAndRename(dictItem);
        const dictKeyList = this.transformKey(remoteKey);
        dictKeyList.forEach(_dictKey => {
          let newItem = JSON.parse(JSON.stringify(_dictItem));
          newItem = this.markValue(_dictKey, newItem);
          newItem = this.toString(_dictKey, newItem);
          dictData[_dictKey] = dictData[_dictKey] || [];
          dictData[_dictKey].push(newItem);
        });
        return dictData;
      }, {});
    } catch (e) {
      console.error('groupByCategoryCode', e);
    }
  }

  // ② 将枚举数据 转换成 界面展示要的数据格式
  pickAndRename(dictItem) {
    const regNums = new RegExp('^\\d+$', 'mg'); // 判断是否是数字。
    const { name, categoryCode } = dictItem;
    // 是否为特殊处理数据
    const isSPecDict = SPEC_DICT.some(item => item === categoryCode);
    let value = dictItem.code;
    value = regNums.test(value) && !isSPecDict ? parseInt(value) : value;
    return { value, code: value, name, label: name };
  }

  // ③ 将分组名称 转换成 界面调用的变量名称
  transformKey(remoteKey) {
    const localKey = LOCAL_DICT_MAP[remoteKey] || remoteKey;
    return typeof localKey === 'string' ? [localKey] : localKey;
  }

  // ④  4.1 先做一次 转换值 的标记
  markValue(dictKey, dictItem) {
    try {
      const transforConfig = LOCAL_TRANSFOR_DICT[dictKey] || '';
      // console.log(transforConfig, '4444');
      if (!transforConfig) return dictItem;
      Object.entries(transforConfig).forEach(([key, value]) => {
        // eslint-disable-next-line eqeqeq
        if (dictItem.value == key) {
          dictItem[TRANSFOR_KEY] = value;
        }
      });
      // console.log(dictItem, '5555');
      return dictItem;
    } catch (e) {
      return dictItem;
    }
  }

  // ④  4.2 全部 value 值标记完后,进行一次 value 转换, 需要在配置项里把冲突项也写出来,避免重复值
  trasnformValue(dictKey, dictData) {
    try {
      const transforConfig = LOCAL_TRANSFOR_DICT[dictKey] || '';
      if (!transforConfig || !dictData.length) return dictData;
      dictData = JSON.parse(JSON.stringify(dictData)); // 字典对照有一对多的关系,需要进行深度拷贝
      return dictData.map(item => {
        if (item[TRANSFOR_KEY]) {
          item.value = item[TRANSFOR_KEY];
        }
        return item;
      });
    } catch (e) {
      return dictData;
    }
  }

  // ⑤ 远程的数据可能会多余本地的数据,需要过滤一次value值
  filterValue(dictKey, dictData) {
    try {
      const filterFunc = LOCAL_FILTER_DICT[dictKey] || '';
      if (!filterFunc || typeof filterFunc !== 'function' || !dictData.length)
        return dictData;
      return dictData.filter(filterFunc);
    } catch (e) {
      return dictData;
    }
  }
  // 判断是否需要将字典值更改为字符串
  toString(dictKey, dictItem) {
    if (!LOCAL_STRING_DICT.includes(dictKey)) return dictItem;
    dictItem.value = dictItem.value + '';
    dictItem.code = dictItem.code + '';
    return dictItem;
  }
}
